module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp3_3016.f6951290.png";